//This is included in the app.jsx
//import 'react-select/dist/react-select.scss';

import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import Select from 'react-select';

import FieldError from '../field-error';

class SingleSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.selected,
        };

        this.onChange = R.bind(this.onChange, this);
    }

    componentDidUpdate({ selected }) {
        if (!this.state.value && selected) {
            this.setState({
                value: selected,
            });
        }
    }

    onChange(event) {
        const value = R.propOr(null, 'value', event);

        this.setState({
            value,
        });

        this.props.onChange({
            target: {
                id: this.props.id,
                value,
            },
        });
    }
    render() {
        const errorId = this.props.id ? `${this.props.id}-error` : null;

        return (
            <FormGroup className="single-select" id={this.props.id}>
                <FormLabel>{this.props.label}</FormLabel>
                {this.state.value}
                {/* react-select owns aria-describedby internally, so the
                    message is associated via aria-errormessage instead */}
                <Select
                    {...(this.props.error && {
                        className: 'is-invalid',
                        'aria-invalid': true,
                        'aria-errormessage': errorId,
                    })}
                    value={R.filter((x) => x.value === this.state.value, this.props.options)}
                    onChange={this.onChange}
                    options={this.props.options}
                />
                <FieldError id={errorId} error={this.props.error} />
            </FormGroup>
        );
    }
}

SingleSelect.propTypes = {
    id: PropTypes.string,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    error: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
};

export default SingleSelect;
